import styled from "styled-components";
import theme from "~/styles/theme";
import { Grid } from "@material-ui/core";
import { Margin } from "~/components/elements";

export const ParticipationInfoHolder = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 105px;
  margin-top: 32px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 224px;
    padding: 0;
    max-width: 1000px;
    justify-content: center;
    margin-top: 64px;

  }

  h3 {
    text-align: center;
  }
`;



export const StyledHeadingContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

export const StyledHeadingLine = styled.div`
  position: absolute;
  width: 100%;
  border-top: 2px solid black;
  top: 50%;
  left: 0;
`;

export const StyledHeadingText = styled.h2`
  position: relative;
  z-index: 5;
  background-color: #B1DBF0;
  font-weight: bold;
  font-size: 36px;
  color: black;
  text-align :center;
  max-width: 300px;

  @media (min-width: 768px) {
    font-size: 40px;
    padding: 0 16px;
    max-width: 600px;
  }
`;

export const PromoCirclesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 30px;
  margin: 0 auto;

  @media (min-width: 400px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 1200px;
  }
  
  @media (min-width: 1022px) {
    grid-template-columns: repeat(4, 1fr);
    max-width: 1200px;
    gap: 67px;
  }
`;

export const PromoContainer = styled.div`
  position: relative;
  width: 176px;  
  height: 176px;


  .promo-circle {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    color: white;
    padding-top: 50px; /* Fixed padding to align all titles */
  }
    
  .promo-background {
    background-color: #0563AF;
    z-index: 1;
  }
    
  .promo-accent {
    background-color: #FCC800;
    z-index: 0;
    left: 8px;
    top: 8px;
  }
    
  .promo-text-main {
    font-size: 24px;
    font-weight: bold;
    color: #FCC800;
    height: 30px; 
    display: flex;
    align-items: center;
  }
    
  .promo-text-description {
    font-size: 18px;
    max-width: 80%;
    line-height: 1.2;
  }

  @media (min-width: 768px) {
    width: 200px;
    height: 200px;

    .promo-text-main {
      font-size: 26px;
    }

    .promo-text-description {
     font-size: 20px;
    }
  }
`

export const Card = styled.div`
  margin-bottom: 32px;
  position: relative;
  border-radius: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 325px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 80px;
    margin-top: 16px;
  }

  h6 {
    font-weight: 600;
    font-size: 20px;
  }

  p,
  h6 {
    color: ${theme.palette.neutral.primary.key};
    text-align: center;
  }

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    font-weight: 400;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      width: 100%;
    }

    strong {
      font-family: ${theme.typography.fontFamily};
      line-height: 0;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        font-weight: 700;
      }
    }
  }

  img {
    background-color: ${theme.palette.neutral.primary.light};
    padding: 16px;
    border-radius: 16px;
    margin: 0 auto;
    width: 80px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding: 30px;
      width: auto;
      border-radius: 24px;
    }
  }
`;

export const BtnStartHolder = styled.div`
  margin: 0 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin: 0 0 0 8px;
  }

  button {
    width: 100%;
  }
`;

export const InfoValidPromotion = styled.small`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin: 16px 16px;
  display: block;
  font-family: ${theme.typography.fontFamilyRegular};
  text-align: center;
  padding: 0px 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    text-align: left;
    margin: 0;
    padding: 0;
  }
`;

export const FullWithMargin = styled(Margin)`
  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 100%;
    max-width: 300px;
  }
`;

export const TextBottomCardContainer = styled(Grid)`
  & > div {
    &:nth-child(1) {
      @media (min-width: ${theme.breakpoints.values.md}px) {
        order: 2;
      }
    }

    &:nth-child(1) {
      order: 1;
    }
  }
`;
